import { DEFAULT_LOCALE, useLocaleData } from 'components/intl-provider/intl-provider.hooks';
import { useLocale } from 'hooks/use-locale.hook';

import React from 'react';
import { IntlProvider as ReactIntlProvider } from 'react-intl';

interface IntlProviderProps {
  children: React.ReactNode;
}

export const IntlProvider: React.FC<IntlProviderProps> = ({ children }: IntlProviderProps): JSX.Element => {
  const userLocale = useLocale();

  // Both halves of what the hook resolved. Taking `messages` and then passing the RAW user tag threw
  // away the normalisation and the Intl-safety check that hook exists to perform — the words came from
  // the resolved locale while every date, number and price came from the unvalidated one.
  const { locale, messages } = useLocaleData(userLocale);

  return (
    <ReactIntlProvider messages={messages} locale={locale} defaultLocale={DEFAULT_LOCALE}>
      {children}
    </ReactIntlProvider>
  );
};
